import React, { useContext } from 'react'
import { GlobalContext, UserContext } from '../../../../App'
import { Autocomplete, TextField } from '@mui/material'

const BaseLocationSelector = ({ form, handleChange }) => {
  const { user } = useContext(UserContext)
  const { selectedBaseLocations } = user
  const { baseLocationOptions } = useContext(GlobalContext)

  return (
    <Autocomplete
      options={baseLocationOptions.filter((x) =>
        selectedBaseLocations.includes(x?._id),
      )}
      value={form.baseLocation}
      disableClearable
      isOptionEqualToValue={(option, value) => option?._id === value._id}
      getOptionDisabled={(opt) => !selectedBaseLocations.includes(opt._id)}
      renderInput={(params) => <TextField {...params} label="Base Location" />}
      onChange={(e, value) => {
        handleChange('baseLocation', value)
      }}
      getOptionLabel={(o) => o.name}
    />
  )
}

export default BaseLocationSelector
